/* jshint esversion: 6 */
import store from '../store';
import router, {HOME_DIR, LOGIN_DIR} from '../router';

export function auth (to, from, next) {
    if (store.getters['auth/checkLogin']) {
        next();
    } else {
        next(false);
        router.rememberRoute = {
            name: to.name,
            params: to.params
        };
        router.replace({name: LOGIN_DIR});
    }
}

export function guest (to, from, next) {
    if (!store.getters['auth/checkLogin']) {
        next();
    } else {
        next(false);
        router.replace({name: HOME_DIR});
    }
}



// WEBPACK FOOTER //
// ./src/router/middleware.js